module.exports = __webpack_public_path__ + "img/equinus_deformation0.782ae751.jpg";